import React from 'react';
import styles from "./Loadable.styles"
import { HEADING } from '../heading/constants/constants';
import Heading from '../heading/Heading';
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../businesslogic/constants/constants';
import { TxSpinner } from '../spinner/TxSpinner';

export default function Loadable({ 
    loadingStates = [PAGE_STATE.LOADING, PAGE_STATE.PRE_LOADING], 
    currentState, 
    children, 
    loadingMessage = "Loading...", 
    isNewLoadable = false, 
    preserveChildMount = false, 
    messageMap = PAGE_STATE_MESSAGE_MAP,
    isFullWidth = true,

}) {

    const message = messageMap[currentState] ?? "";

    const renderOverlayLoader = () => {
        return (
            <>
                {(loadingStates.indexOf(currentState) > -1) && <div style={styles.overlay}>
                    <Heading type={HEADING.H2} customStyle={styles.loadingText}>{loadingMessage}</Heading>
                </div>}

                {children}
            </>
        )
    }

    if(isNewLoadable){
        if (loadingStates.indexOf(currentState) > -1) {
            if (preserveChildMount) {
                return <>
                    {children}
                    <div style={styles.overlay}>
                        <TxSpinner message={message} customStyles={styles.preserveChildMountLoaderColor} isFullWidth={isFullWidth}/> 
                    </div>
                </>
            } else {
                return <TxSpinner message={message} isFullWidth={isFullWidth}/> ;
            }
        }
    } else {
        return renderOverlayLoader();
    }

    return children;
}